module.exports = __webpack_public_path__ + "img/ring_y_0_0_0.8fec8c7e.png";